
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NavbarComp',
  props: {
    msg: String
  }
})
